import {
  CompaniesInfiniteSelectField,
  DefaultRouteTabs,
  FloatingFormItem,
} from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import React, { useEffect } from 'react';

import { Alert, Button, Col, Form, Row } from 'antd';
import ScheduleCreateModal from '@/components/Schedules/Kanban/ScheduleCreateModal';
import { useDisclosure } from '@/hooks';
import ScheduleDragDropContext from '@/components/Schedules/Kanban/ScheduleDragDropContext';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import SpaceForButton from '@/components/_common/SpaceForButtons';

const ScheduleKanbanPage: React.FC<PageProps> = ({ route }) => {
  const [form] = Form.useForm<{ companyIds: number[] }>();

  const companyIds = Form.useWatch('companyIds', form);

  const [scheduleAddOpened, scheduleAddAction] = useDisclosure();

  useEffect(() => {
    const storageCompanyIds = localStorage.getItem('uc-schedule-companyIds');
    if (storageCompanyIds?.length) {
      form.setFieldValue(
        'companyIds',
        storageCompanyIds.split(',').map(Number),
      );
    }
  }, []);

  return (
    <>
      <DefaultRouteTabs
        route={route.parent}
        basePath="/app/schedules"
        permissions={route.permissions}
        extra={
          <SpaceForButton>
            <Button
              block
              type="primary"
              disabled={!hasPermissions([Authorities.SHEDULE_EVERYTHING_VIEW])}
              onClick={scheduleAddAction.open}
            >
              Criar agendamento
            </Button>
          </SpaceForButton>
        }
      >
        <Form form={form}>
          <Row gutter={[24, 24]}>
            <Col span={24} md={12} lg={9}>
              <FloatingFormItem
                label="Selecione uma empresa"
                name="companyIds"
                getValueFromEvent={(id) => {
                  localStorage.setItem('uc-schedule-companyIds', String(id));
                  return id;
                }}
              >
                <CompaniesInfiniteSelectField
                  mode="multiple"
                  queryEnable
                  queryFilter={{ rows: 50 }}
                />
              </FloatingFormItem>
            </Col>
          </Row>
        </Form>

        {!!companyIds?.length && (
          <ScheduleDragDropContext queryParams={{ companyIds }} />
        )}

        <Alert
          style={{ marginTop: 24 }}
          description={
            <>
              <strong>
                A tela de pátio e acompanhamento tiveram mudanças.
              </strong>
              <div>
                Com a nova funcionalidade de status do orçamento, agora será
                possível fazer o acompanhamento dos orçamentos da sua oficina de
                forma mais visual.
              </div>
              <div>
                As colunas do kanban agora são os status do orçamento, gerencie
                os status pela tela de configuração do sistema.
              </div>
              <div>
                Agendamentos sem status são automaticamente movimentado para
                coluna pendentes, mova os cartões para as colunas desejada
                conforme o fluxo de processo da sua oficina
              </div>
            </>
          }
        />
      </DefaultRouteTabs>

      <ScheduleCreateModal
        companyIds={companyIds}
        open={scheduleAddOpened}
        onCancel={scheduleAddAction.close}
      />
    </>
  );
};

export default ScheduleKanbanPage;
